import React from 'react';
import { Select } from 'antd';
import { MetaData } from 'models/MetaData/metaData.model';
import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';

export interface SelectDropdownProps {
  options: MetaData[];
  value?: string;
  onChange: (value: string) => void;
  placeholder: string;
  allowClear?: boolean;
  disabled?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

const Dropdown: React.FC<SelectDropdownProps> = ({
  options,
  value,
  onChange,
  placeholder,
  allowClear,
  disabled,
  className,
  style,
}) => {
  const getPopupContainer = (trigger: HTMLElement): HTMLElement => {
    return (trigger.parentNode as HTMLElement) || trigger;
  };
  return (
    <Select
      className={className}
      style={style}
      getPopupContainer={getPopupContainer}
      value={value}
      suffixIcon={<Arrow fontSize={44} />}
      placeholder={placeholder}
      allowClear={allowClear}
      disabled={disabled}
      onChange={onChange}
      dropdownMatchSelectWidth={false}
      options={options}
      listHeight={120}
    />
  );
};

export default Dropdown;
